<template>
  <div id="app">
    <router-view v-if="!loading" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import contractServices from "./services/contract";
import contractStepServices from "./services/contract-step";
import contractStatusServices from "./services/contract-status";
import contractActionServices from "./services/contract-action";
import organizationServices from "@/services/organization";

import authServices from "@/services/auth";

export default {
  name: 'App',
  data() {
    return {
      loading: false,
      loginInfo: authServices.loginInfo(),
    }
  },
  beforeMount() {
    if (this.loginInfo) {
      this.loading = true;
      Promise.all([
        this.setAllCategories(),
        this.getAllContracts(),
        this.getAllContractSteps(),
        this.getAllContractStatus(),
        this.getAllContractActions(),
      ]).finally(() => {
        this.loading = false
      })
    }
  },
  methods: {
    ...mapActions("contract", [
      "setAllContracts",
      "setAllContractSteps",
      "setAllContractStatus",
      "setAllContractActions",
    ]),
    ...mapActions("category", ["setAllCategories"]),
    getAllContracts() {
      contractServices.list({
        offset: 0,
        limit: 999,
        locale: "vi",
        organization_id: organizationServices.getCurrentOrg()?.id,
        sort: "-created",
        filters: {
          status: "enable"
        }
      }).then((response) => {
        this.setAllContracts(response.items.map((item) => ({
          id: item.id,
          name: item.translations?.vi?.name,
          contract_type: item.contract_type,
          switching_statuses: item.switching_statuses
        })).filter((c) => !!c.name))
      })
    },
    getAllContractSteps() {
      contractStepServices.list({
        offset: 0,
        limit: 999,
        locale: "vi",
        organization_id: organizationServices.getCurrentOrg()?.id
      }).then((response) => {
        this.setAllContractSteps(response.items.map((item) => ({
          id: item.id,
          name: item.translations?.vi?.name,
          contract_id: item.contract_id,
          order: item.order,
          roles: item.roles,
          role_ids: item.role_ids,
          actions: item.actions
        })))
      })
    },
    getAllContractStatus() {
      contractStatusServices.list({
        offset: 0,
        limit: 999,
        locale: "vi",
        organization_id: organizationServices.getCurrentOrg()?.id
      }).then((response) => {
        this.setAllContractStatus(response.map((item) => {
          return item.switching_statuses.map((s) => ({
            value: s.value,
            name: s.translations?.vi?.name || s.menu || s.label,
            menu: s.menu || s.label,
            label: s.label || s.menu,
          }))
        }).flat());
      })
    },
    getAllContractActions() {
      contractActionServices.list({
        offset: 0,
        limit: 999,
        locale: "vi",
        organization_id: organizationServices.getCurrentOrg()?.id
      }).then((response) => {
        this.setAllContractActions(response.items.map((item) => ({
          id: item.id,
          name: item.translations?.vi?.name,
          order: item.order,
        })))
      })
    },
  }
}
</script>

<style></style>
